module.exports = __webpack_public_path__ + "static/productos@2xl-048a3801de5c6599a1e6e9e5c5fc334a.webp";